import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";

const MODES = [["both", "Alternate: path sequence / fragment riddle"], ["sequence", "Path sequences only"], ["riddle", "Fragment riddles only"]];

// How the console lock behaves before each new memory.
export const ChallengeSettings = ({ value = {}, onChange }) => {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <section data-testid="challenge-settings" className="grid gap-5 border border-cyan-400/30 bg-slate-950/70 p-6">
      <div>
        <p className="lab-label !text-cyan-300">Console lock // before each memory</p>
        <p className="mt-1 text-xs text-slate-500">The hive cannot place a new memory until the audience clarifies it on the button boxes. Wrong answers show a hint after two fails; the hive gives in after the number below.</p>
      </div>
      <label className="flex items-center gap-3 font-mono text-sm uppercase tracking-widest text-slate-200">
        <input data-testid="challenge-enabled" type="checkbox" checked={value.enabled ?? true} onChange={(e) => set({ enabled: e.target.checked })} className="h-4 w-4 accent-cyan-300" />
        Lock memories behind the console
      </label>
      <div className="grid gap-4 sm:grid-cols-[1fr_120px_120px_140px]">
        <div>
          <span className="lab-label">Lock type</span>
          <Select value={value.mode || "both"} onValueChange={(mode) => set({ mode })}>
            <SelectTrigger data-testid="challenge-mode" className="mt-2 w-full rounded-none border-slate-700 bg-slate-900 font-mono text-xs uppercase tracking-widest"><SelectValue /></SelectTrigger>
            <SelectContent className="lab-dialog">{MODES.map(([v, l]) => <SelectItem key={v} value={v} className="font-mono text-xs uppercase tracking-widest">{l}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div>
          <span className="lab-label">First path length</span>
          <input data-testid="challenge-min-steps" type="number" min="1" max="10" value={value.min_steps ?? 3} onChange={(e) => set({ min_steps: Number(e.target.value) })} className="lab-input mt-2 w-full font-mono" />
        </div>
        <div>
          <span className="lab-label">Longest path</span>
          <input data-testid="challenge-max-steps" type="number" min="1" max="12" value={value.max_steps ?? 6} onChange={(e) => set({ max_steps: Number(e.target.value) })} className="lab-input mt-2 w-full font-mono" />
        </div>
        <div>
          <span className="lab-label">Hive gives in after</span>
          <input data-testid="challenge-give-in" type="number" min="1" max="10" value={value.give_in_after ?? 3} onChange={(e) => set({ give_in_after: Number(e.target.value) })} className="lab-input mt-2 w-full font-mono" />
        </div>
      </div>
    </section>
  );
};
